import { render, staticRenderFns } from "./AdminContent.vue?vue&type=template&id=6667bba6&"
import script from "./AdminContent.vue?vue&type=script&lang=js&"
export * from "./AdminContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports